module.exports = __webpack_public_path__ + "static/media/galerija_2018 (1).c502f3ea.jpg";